class DocumentScrollEvent {}

export default DocumentScrollEvent;
